import React, { useMemo, useState } from "react";
import Dialog from "../../../Components/common/Dialog";
import HealthCard from "./HealthCard";
import { formatNumber } from "../utils";

const NotVisitedRecently = ({
  translate,
  data,
  loading,
  onScheduleAll,
  onExport,
}) => {
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("unused");
  const [search, setSearch] = useState("");

  // fmd/23: unusedPlates / usedPlates (+ unusedPlatesCount / usedPlatesCount / totalPlates)
  const notVisited = useMemo(() => {
    if (Array.isArray(data?.unusedPlates)) return data.unusedPlates;
    if (Array.isArray(data?.notVisited)) return data.notVisited;
    return [];
  }, [data]);

  const visited = useMemo(() => {
    if (Array.isArray(data?.usedPlates)) return data.usedPlates;
    if (Array.isArray(data?.visited)) return data.visited;
    return [];
  }, [data]);

  const total =
    Number(
      data?.totalPlates ??
        data?.totalVehicles ??
        notVisited.length + visited.length,
    ) || notVisited.length + visited.length;
  const unusedCount = Number(data?.unusedPlatesCount ?? notVisited.length);
  const usedCount = Number(data?.usedPlatesCount ?? visited.length);
  const coverage = total ? (usedCount / total) * 100 : 0;

  const modalList = useMemo(() => {
    let list = [];
    if (filter !== "used") {
      list = list.concat(notVisited.map((p) => ({ p, used: false })));
    }
    if (filter !== "unused") {
      list = list.concat(visited.map((p) => ({ p, used: true })));
    }
    const q = search.trim().toLowerCase();
    if (q) {
      list = list.filter((item) =>
        String(typeof item.p === "string" ? item.p : item.p?.plate || "")
          .toLowerCase()
          .includes(q),
      );
    }
    return list;
  }, [filter, notVisited, visited, search]);

  return (
    <>
      <HealthCard
        className="fh-span-3"
        title={translate("vehiclesNotVisitedRecently")}
        subtitle={translate("vehiclesNotVisitedRecentlySub")}
        loading={loading}
      >
        <div
          style={{
            display: "flex",
            gap: 24,
            margin: "4px 0 10px",
            alignItems: "flex-end",
          }}
        >
          <div>
            <div className="fh-kpi" style={{ color: "#e0484c" }}>
              {formatNumber(unusedCount)}
            </div>
            <div className="fh-card-sub" style={{ margin: 0 }}>
              {translate("vehicleNotVisited")}
            </div>
          </div>
          <div>
            <div className="fh-kpi" style={{ fontSize: 20, color: "#3f9c40" }}>
              {formatNumber(usedCount)}
            </div>
            <div className="fh-card-sub" style={{ margin: 0 }}>
              {translate("vehiclePanetration")}
            </div>
          </div>
          <div>
            <div className="fh-kpi" style={{ fontSize: 20 }}>
              {formatNumber(total)}
            </div>
            <div className="fh-card-sub" style={{ margin: 0 }}>
              {translate("totalPlates")}
            </div>
          </div>
        </div>

        <div className="fh-bar-top">
          <span>{translate("serviceCoverage")}</span>
          <b>{formatNumber(coverage, 1)}%</b>
        </div>
        <div className="fh-track" style={{ height: 6 }}>
          <div
            className="fh-fill"
            style={{
              width: `${Math.min(coverage, 100)}%`,
              background: coverage < 20 ? "#e0484c" : "#5cb85c",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            gap: 10,
            marginTop: "auto",
            paddingTop: 8,
            flexWrap: "wrap",
          }}
        >
          {/* <button
            type="button"
            className="fh-btn"
            onClick={() => onScheduleAll && onScheduleAll(notVisited)}
          >
            {translate("scheduleAll")}
          </button>*/}
          <button
            type="button"
            className="fh-btn ghost"
            onClick={() => setOpen(true)}
          >
            {translate("viewVehicles")}
          </button>
          {/* <button
            type="button"
            className="fh-btn ghost"
            onClick={() => onExport && onExport({ notVisited, visited })}
          >
            {translate("export")}
          </button>*/}
        </div>
        {/*  <div
          className="fh-note"
          style={{ background: "transparent", border: "none", padding: 0 }}
        >
          {translate("scheduleAllNotVisitedNote")}
        </div>*/}
      </HealthCard>

      {open ? (
        <Dialog
          onClose={() => setOpen(false)}
          title={translate("vehiclesNotVisitedRecently")}
          maxWidth="md"
          fullWidth
          isVisableBtn
          cancelText={translate("sharedCancel")}
        >
          <div style={{ padding: 12 }}>
            <div
              style={{
                display: "flex",
                gap: 8,
                marginBottom: 12,
                flexWrap: "wrap",
              }}
            >
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder={translate("searchPlate")}
                style={{
                  flex: 1,
                  minWidth: 160,
                  padding: "7px 10px",
                  border: "1px solid #e3e7eb",
                  borderRadius: 4,
                  fontSize: 12,
                }}
              />
              {["unused", "used", "all"].map((key) => (
                <button
                  key={key}
                  type="button"
                  className={`fh-btn sm ghost ${filter === key ? "on" : ""}`}
                  style={
                    filter === key
                      ? {
                          background: "#2b3945",
                          color: "#fff",
                          borderColor: "#2b3945",
                        }
                      : undefined
                  }
                  onClick={() => setFilter(key)}
                >
                  {key === "unused"
                    ? translate("notVisited")
                    : key === "used"
                      ? translate("visited")
                      : translate("all")}
                </button>
              ))}
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 6,
                maxHeight: 320,
                overflow: "auto",
              }}
            >
              {modalList.length ? (
                modalList.map((item, index) => {
                  const label =
                    typeof item.p === "string"
                      ? item.p
                      : item.p?.plate || item.p?.plateNo || "—";
                  return (
                    <span
                      key={`${label}-${index}`}
                      className={`fh-plate ${item.used ? "used" : ""}`}
                    >
                      {label}
                    </span>
                  );
                })
              ) : (
                <div className="fh-empty">{translate("noPlatesMatch")}</div>
              )}
            </div>
            <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
              {/* <button
                type="button"
                className="fh-btn"
                onClick={() => onScheduleAll && onScheduleAll(notVisited)}
              >
                {translate("scheduleAll")}
              </button>*/}
              <button
                type="button"
                className="fh-btn ghost"
                onClick={() => setOpen(false)}
              >
                {translate("close")}
              </button>
            </div>
          </div>
        </Dialog>
      ) : null}
    </>
  );
};

export default NotVisitedRecently;
